import { Button } from '@polichat/flamboyant';
import { useSelector } from 'react-redux';

export function FeatureMessage() {
  return null;
  // TODO: Retornar a funcionalidade de mensagem de recurso quando botflow estiver pronto
  // const role = useSelector((state: any) => state.chat?.config?.user?.superRole);

  // if (['manager', 'adm'].includes(role)) {
  //   return (
  //     <>
  //       <p>
  //         Descubra agora um recurso gratuito que pode potencializar seus
  //         resultados!
  //       </p>
  //       <Button onClick={() => alert('teste')}>Conhecer agora!</Button>
  //     </>
  //   );
  // }

  // return (
  //   <>
  //     <p>
  //       Temos um novo recurso gratuito que pode potencializar seus resultados!
  //       Avise o gestor para que ele libere essa funcionalidade.
  //     </p>
  //   </>
  // );
}
